import { render, staticRenderFns } from "./BeneficiaryForm.vue?vue&type=template&id=06a56656&scoped=true&"
import script from "./BeneficiaryForm.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryForm.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryForm.vue?vue&type=style&index=0&id=06a56656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a56656",
  null
  
)

export default component.exports